export const GQL_URL =
  import.meta.env.VITE_GQL_URL ?? 'http://localhost:3001/graphql';
